module.exports = __webpack_public_path__ + "img/yfood-happy-banana.cf0864dc.png";